import { lazy } from 'react'

export const ThankYouForYourTrust = lazy(
  () => import('./v1/ThankYouForYourTrust'),
)
export const ThankYouForYourTrustV2 = lazy(
  () => import('./v2/ThankYouForYourTrustV2'),
)
